export { Switch, renderSwitch, useSwitch } from './components/Switch/index';
export type { SwitchSlots, SwitchProps, SwitchState } from './components/Switch/index';
